import { z } from "zod";
import { apiClient } from "../client";
import { categoryAttributeSchema, categorySchema } from "./schemas";
import type {
  Category,
  CategoryAttribute,
  CreateCategoryRequest,
  ReorderCategoriesRequest,
} from "./types";

export async function getCategories(): Promise<Category[]> {
  const response = await apiClient.get("categories", {}).json<Category[]>();

  return z.array(categorySchema).parse(response);
}

export async function getCategory(id: string | number): Promise<Category> {
  const response = await apiClient.get(`categories/${id}`, {}).json<Category>();

  return categorySchema.parse(response);
}

export async function getCategoryAttributes(): Promise<CategoryAttribute[]> {
  const response = await apiClient
    .get("categoryAttributes", {})
    .json<CategoryAttribute[]>();

  return z.array(categoryAttributeSchema).parse(response);
}

export async function getCategoryAttributesByCategoryId(
  categoryId: string | number
): Promise<CategoryAttribute[]> {
  const response = await apiClient
    .get(`categories/${categoryId}/attributes`, {})
    .json<CategoryAttribute[]>();

  return z.array(categoryAttributeSchema).parse(response);
}

export async function createCategory(
  data: CreateCategoryRequest
): Promise<Category> {
  const response = await apiClient
    .post("categories", { json: data })
    .json<Category>();

  return categorySchema.parse(response);
}

export async function updateCategory(
  id: string | number,
  data: CreateCategoryRequest
): Promise<Category> {
  const response = await apiClient
    .put(`categories/${id}`, { json: data })
    .json<Category>();

  return categorySchema.parse(response);
}

export async function deleteCategory(id: string | number): Promise<void> {
  await apiClient.delete(`categories/${id}`, {});
}

export async function reorderCategories(
  data: ReorderCategoriesRequest
): Promise<void> {
  await apiClient.put("categories/reorder", { json: data });
}

export async function getCategoriesNavigation(): Promise<Category[]> {
  const response = await apiClient
    .get("categories/navigation", {})
    .json<Category[]>();

  return z.array(categorySchema).parse(response);
}

export async function getCategoryFileContent(fileId: string): Promise<Blob> {
  const response = await apiClient.get(`files/${fileId}/content`, {});
  return response.blob();
}

export async function bulkDownloadFiles(fileIds: string[]): Promise<Blob> {
  const response = await apiClient.post("files/bulk/download", {
    json: { fileIds },
  });
  return response.blob();
}
